import React from 'react';
import { Box, Typography } from '@mui/material';

interface MarqueeTextProps {
  text: string;
  sx?: object;
}

const MarqueeText: React.FC<MarqueeTextProps> = ({ text, sx }) => {
  const trimmed = text.trim();
  const shouldAnimate = trimmed.length > 8 && trimmed !== '—';

  if (!shouldAnimate) {
    return (
      <Typography sx={{ color: '#aaa', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', ...sx }}>
        {trimmed || ' '}
      </Typography>
    );
  }

  const loopText = `${trimmed}   ·   ${trimmed}`;

  return (
    <Box sx={{ overflow: 'hidden', width: '100%', minWidth: 0, ...sx }}>
      <Box
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          color: '#aaa',
          fontSize: 11,
          animation: 'audioMarquee 14s linear infinite',
          willChange: 'transform',
          '@keyframes audioMarquee': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
        }}
      >
        {loopText}
      </Box>
    </Box>
  );
};

export default MarqueeText;
